<template>
  <div
    v-if="scenarioBoxTopic"
    class="scenario-box-container"
    @click="toggleContent"
  >
    <div class="title-bar">
      <div
        class="box-action"
      >
        <span>{{ actionText }}</span>
        <icon
          :name="actionIcon"
          variant="7B7B7B"
        />
      </div>
    </div>
    <div
      v-if="showContent"
      class="content"
    >
      <topic
        :topic="scenarioBoxTopic"
        :show-title="false"
      />
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';
import Topic from '@/components/topics/topic.vue';

export default {
  components: { Icon, Topic },
  props: {
    flashcard: {
      type: Object,
    },
  },
  data() {
    return {
      showContent: true,
    };
  },
  computed: {
    actionIcon() {
      return this.showContent ? 'arrow-up' : 'arrow-down';
    },
    actionText() {
      return this.showContent ? 'Hide' : 'Show';
    },
    scenarioBoxTopic() {
      if (this.$route.name.includes('scenario')) {
        const grouping = this.$store.getters['groupings/list'].find(grouping => {
          return grouping?.productAssociations.find(pa => pa.categoryId === parseInt(this.$route.params.categoryId));
        });
        const isFlashcardAssociated = grouping?.assetAssociations.find(aa => this.flashcard.id === aa.assetBId);
        if (grouping.groupingType === 'Scenario Box' && isFlashcardAssociated) {
          const scenarioBoxTopicAssociation = grouping.assetAssociations.find(aa => aa.assetBType === 'Topic');
          this.$store.dispatch('topics/load', { ids: [scenarioBoxTopicAssociation?.assetBId] });
          return this.$store.getters['topics/topics'][`${scenarioBoxTopicAssociation?.assetBId}`];
        }
      } else {
        const scenarioBoxAssetAssociation = this.flashcard?.assetAssociations.find(assetAssociation => assetAssociation?.displayType === 'scenario_box');
        return this.$store.getters['topics/topics'][scenarioBoxAssetAssociation?.assetBId];
      }
    },
  },
  methods: {
    toggleContent() {
      this.showContent = !this.showContent;
    },
  },
};
</script>

<style lang='scss' scoped>
  .scenario-box-container {
    padding: rem-calc(12) rem-calc(20);
    padding-bottom: 0;
    margin-bottom: rem-calc(35);
    border: 1px solid #E9E9E9;
    border-radius: rem-calc(4);
    background: #FAFAFA;
    cursor: pointer;
    .title-bar {
      display: flex;
      justify-content: space-between;
      padding-bottom: rem-calc(12);
      .title {
        font-size: rem-calc(14);
        line-height: rem-calc(16);
        font-weight: $bold;
      }
      .box-action {
        display: flex;
        margin-left: auto;
        font-size: rem-calc(12);
        line-height: rem-calc(16);
        font-weight: $semi-bold;
        color: #7B7B7B;
        img {
          width: rem-calc(10);
          margin-left: rem-calc(8);
        }
      }
    }
    .content {
      display: flex;
      padding-bottom: rem-calc(12);
      /deep/ .top-content {
        padding: 0;
        .content {
          margin: 0;
          p {
            margin: 0;
            color: #000000;
          }
        }
      }
    }
  }
</style>
